export enum TipologiaAttivitaComm {
  'MARKETING',
  'DEMO',
  'ALTRO',
  'VISITA',
  'TELEFONATA',
  'SEGNALAZIONE AUTODESK',
}

export enum StatoAttivitaComm {
  'PROGRAMMATA',
  'IN CORSO',
  'COMPLETATA CON VENDITA',
  'COMPLETATA',
  'DA APPROVARE',
  'APPROVATA',
  'NON APPROVATA',
}
